export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const ADD_PRODUCTS = 'ADD_PRODUCTS';

// Login - Get Cookie With Token
export const setCurrentUser = userInfo => async dispatch => {
	return dispatch({
		type: SET_CURRENT_USER,
		payload: userInfo,
	});
};

export const setProducts = products => dispatch => {
	return dispatch({
		type: ADD_PRODUCTS,
		payload: products,
	});
};
